// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from "./ienvironment";

export const environment: IEnvironment = {
  name: "development",
  clientCode: "pps",
  clientName: "PPS Servicing Pty Ltd",
  appFullName: "PPS Management System",
  appName: "PPS Management System",
  clientUrl: "http://ppsservicing.com.au/",
  clientLogo: "./assets/pps_logo_white.png",
  version: "5.0.0",
  production: false,
  clientId: "pps_management_system",
  clientRoot: "https://dev.zoesen.com/",
  stsAuthority: "https://auth-dev.zoesen.com",
  apiRoot: "https://api-dev.zoesen.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
